import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const settingsStore = useSettingsStore();
    const {
      collapse
    } = storeToRefs(settingsStore);
    const {
      toggleCollapse
    } = settingsStore;
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      return _openBlock(), _createBlock(_component_vab_icon, {
        class: "fold-unfold",
        icon: _unref(collapse) ? 'menu-unfold-line' : 'menu-fold-line',
        onClick: _unref(toggleCollapse)
      }, null, 8, ["icon", "onClick"]);
    };
  }
});